// Module
var code = "<react-component name=\"BulkSequenceEnrolment\"></react-component>\n";
// Exports
module.exports = code;